export default {"src":"/_next/static/media/Unsupported.387fd954.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};